import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { toast } from 'react-toastify';
import ExpenseList from '../../components/Expenses/ExpenseList';
import expenseService from '../../services/expenseService';
import projectService from '../../services/projectService';
import budgetService from '../../services/budgetService';

const Expenses = () => {
  const [expenses, setExpenses] = useState([]);
  const [projects, setProjects] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async (appliedFilters = {}) => {
    setLoading(true);
    try {
      const [expensesData, projectsData, budgetsData] = await Promise.all([
        expenseService.getAllExpenses(appliedFilters),
        projectService.getAllProjects(),
        budgetService.getAllBudgets()
      ]);
      setExpenses(expensesData.data || []);
      setProjects(projectsData.projects || []);
      setBudgets(budgetsData.data || []);
      setFilters(appliedFilters);
    } catch (error) {
      console.error('Error loading data:', error);
      toast.error('Failed to load expenses');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await expenseService.deleteExpense(id);
      toast.success('Expense deleted successfully');
      loadData(filters);
    } catch (error) {
      console.error('Error deleting expense:', error);
      toast.error(error.response?.data?.error || 'Failed to delete expense');
    }
  };

  const handleRefresh = (newFilters) => {
    loadData(newFilters);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading expenses...</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Expenses</h1>
          <p className="text-gray-600 mt-1">Track and manage project expenses</p>
        </div>
        <Link
          to="/app/expenses/new"
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <FiPlus className="mr-2" />
          New Expense
        </Link>
      </div>

      <ExpenseList
        expenses={expenses}
        projects={projects}
        budgets={budgets}
        onDelete={handleDelete}
        onRefresh={handleRefresh}
      />
    </div>
  );
};

export default Expenses;

